export const PENDING_AMAZON_SELLER_ACCOUNTS_ACTION =
  'PENDING_AMAZON_SELLER_ACCOUNTS_ACTION'
export const SET_AMAZON_SELLER_ACCOUNTS_DATA = 'SET_AMAZON_SELLER_ACCOUNTS_DATA'
export const SET_AMAZON_SELLER_ACCOUNT_SELECTOR_DATA =
  'SET_AMAZON_SELLER_ACCOUNT_SELECTOR_DATA'
